(function () {
  'use strict';

  function initSection(section) {
    if (!section || section.oddItProductGridInitialized) return;
    section.oddItProductGridInitialized = true;

    var sidebar = section.querySelector('[data-oddit-filter-sidebar]');
    var backdrop = section.querySelector('[data-oddit-filter-backdrop]');
    var openTrigger = section.querySelector('[data-oddit-filter-open]');
    var closeTrigger = section.querySelector('[data-oddit-filter-close]');
    var toggles = section.querySelectorAll('[data-oddit-filter-toggle]');
    var resetButton = section.querySelector('[data-oddit-reset-filters]');
    var checkboxes = section.querySelectorAll('.oddit-section-product-grid__filter-checkbox');
    var mobileQuery = window.matchMedia('(min-width: 990px)');

    function isDesktop() {
      return mobileQuery.matches;
    }

    function syncSidebarVisibility() {
      if (!sidebar) return;
      if (isDesktop()) {
        sidebar.removeAttribute('aria-hidden');
      } else if (!sidebar.classList.contains('is-open')) {
        sidebar.setAttribute('aria-hidden', 'true');
      }
    }

    function openDrawer() {
      if (!sidebar) return;
      sidebar.classList.add('is-open');
      sidebar.removeAttribute('aria-hidden');
      if (backdrop) backdrop.classList.add('is-open');
      if (openTrigger) openTrigger.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      var firstField = sidebar.querySelector('button, input, a');
      if (firstField) firstField.focus();
    }

    function closeDrawer() {
      if (!sidebar) return;
      // Drawer changes only apply via the results button; closing discards them.
      if (filterForm) filterForm.reset();
      setResultsLabel(section.getAttribute('data-oddit-results-count'));
      sidebar.classList.remove('is-open');
      if (!isDesktop()) sidebar.setAttribute('aria-hidden', 'true');
      if (backdrop) backdrop.classList.remove('is-open');
      if (openTrigger) {
        openTrigger.setAttribute('aria-expanded', 'false');
        openTrigger.focus();
      }
      document.body.style.overflow = '';
    }

    function handleKeydown(event) {
      if (!sidebar || !sidebar.classList.contains('is-open')) return;
      if (event.key === 'Escape') {
        closeDrawer();
      } else if (event.key === 'Tab') {
        var focusables = Array.prototype.filter.call(
          sidebar.querySelectorAll('button, a[href], input'),
          function (el) { return el.offsetParent !== null; }
        );
        if (!focusables.length) return;
        var first = focusables[0];
        var last = focusables[focusables.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }
    }

    function handleResetClick() {
      checkboxes.forEach(function (checkbox) {
        checkbox.checked = false;
      });
    }

    if (openTrigger) {
      openTrigger.setAttribute('aria-expanded', 'false');
      openTrigger.addEventListener('click', openDrawer);
    }
    if (closeTrigger) {
      closeTrigger.addEventListener('click', closeDrawer);
    }
    if (backdrop) {
      backdrop.addEventListener('click', closeDrawer);
    }

    section.addEventListener('keydown', handleKeydown);

    syncSidebarVisibility();
    if (typeof mobileQuery.addEventListener === 'function') {
      mobileQuery.addEventListener('change', syncSidebarVisibility);
    }

    toggles.forEach(function (toggle) {
      toggle.addEventListener('click', function () {
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        var panelId = toggle.getAttribute('aria-controls');
        var panel = panelId ? document.getElementById(panelId) : null;
        toggle.setAttribute('aria-expanded', String(!expanded));
        if (panel) {
          if (expanded) {
            panel.setAttribute('hidden', '');
          } else {
            panel.removeAttribute('hidden');
          }
        }
      });
    });

    if (resetButton && checkboxes.length) {
      resetButton.addEventListener('click', handleResetClick);
    }

    var filterForm = section.querySelector('[data-oddit-filter-form]');
    var viewResults = section.querySelector('[data-oddit-view-results]');
    var viewResultsLabel = section.querySelector('[data-oddit-view-results-label]');
    var countRequest = 0;

    function isDrawerOpen() {
      return !!sidebar && sidebar.classList.contains('is-open') && !isDesktop();
    }

    function filterQuery() {
      var params = new URLSearchParams();
      new FormData(filterForm).forEach(function (value, key) {
        // Groups can share one Shopify filter, so the same value may appear twice; skip empties and repeats.
        if (value === '' || params.getAll(key).indexOf(value) !== -1) return;
        params.append(key, value);
      });
      return params.toString();
    }

    function submitFilters() {
      var query = filterQuery();
      window.location.href = filterForm.getAttribute('action') + (query ? '?' + query : '');
    }

    function setResultsLabel(count) {
      if (!viewResults || !viewResultsLabel || count == null) return;
      viewResultsLabel.textContent = viewResults.getAttribute('data-label').replace('X', count);
    }

    // Re-render this section for the pending filters and read its count attribute.
    function updateResultsCount() {
      if (!viewResults) return;
      var request = ++countRequest;
      var query = filterQuery();
      var url = filterForm.getAttribute('action') + '?' + (query ? query + '&' : '') + 'section_id=' + encodeURIComponent(section.id);
      fetch(url)
        .then(function (response) { return response.text(); })
        .then(function (html) {
          var match = html.match(/data-oddit-results-count="(\d+)"/);
          if (request === countRequest && match) setResultsLabel(match[1]);
        })
        .catch(function () {});
    }

    if (viewResults) {
      viewResults.addEventListener('click', submitFilters);
    }

    if (filterForm) {
      filterForm.addEventListener('change', function (event) {
        var target = event.target;
        if (target.type === 'checkbox') {
          checkboxes.forEach(function (checkbox) {
            if (checkbox.name === target.name && checkbox.value === target.value) checkbox.checked = target.checked;
          });
        }
        if (isDrawerOpen()) {
          updateResultsCount();
        } else {
          submitFilters();
        }
      });
      filterForm.addEventListener('submit', function (event) {
        event.preventDefault();
        submitFilters();
      });
    }

    var sortWrap = section.querySelector('[data-oddit-sort]');
    var sortToggle = section.querySelector('[data-oddit-sort-toggle]');
    var sortMenu = section.querySelector('[data-oddit-sort-menu]');
    var sortOptions = sortMenu ? Array.prototype.slice.call(sortMenu.querySelectorAll('[role="menuitem"]')) : [];

    // Keep the active filter params when changing sort; drop page so results restart at 1.
    sortOptions.forEach(function (option) {
      var params = new URLSearchParams(window.location.search);
      params.set('sort_by', option.getAttribute('data-sort-value'));
      params.delete('page');
      option.href = window.location.pathname + '?' + params.toString();
    });

    function openSort(focusIndex) {
      sortMenu.removeAttribute('hidden');
      sortToggle.setAttribute('aria-expanded', 'true');
      var current = sortOptions.findIndex(function (o) { return o.getAttribute('aria-current') === 'true'; });
      var index = typeof focusIndex === 'number' ? focusIndex : Math.max(current, 0);
      if (sortOptions[index]) sortOptions[index].focus();
    }

    function closeSort(returnFocus) {
      if (!sortMenu || sortMenu.hasAttribute('hidden')) return;
      sortMenu.setAttribute('hidden', '');
      sortToggle.setAttribute('aria-expanded', 'false');
      if (returnFocus) sortToggle.focus();
    }

    function handleDocumentClick(event) {
      if (sortWrap && !sortWrap.contains(event.target)) closeSort(false);
    }

    if (sortToggle && sortMenu) {
      sortToggle.addEventListener('click', function () {
        if (sortMenu.hasAttribute('hidden')) {
          openSort();
        } else {
          closeSort(true);
        }
      });
      sortToggle.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          openSort(event.key === 'ArrowUp' ? sortOptions.length - 1 : 0);
        } else if (event.key === 'Escape') {
          closeSort(true);
        }
      });
      sortMenu.addEventListener('keydown', function (event) {
        var index = sortOptions.indexOf(document.activeElement);
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          var step = event.key === 'ArrowDown' ? 1 : -1;
          sortOptions[(index + step + sortOptions.length) % sortOptions.length].focus();
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          sortOptions[event.key === 'Home' ? 0 : sortOptions.length - 1].focus();
        } else if (event.key === 'Escape') {
          event.stopPropagation();
          closeSort(true);
        } else if (event.key === 'Tab') {
          closeSort(false);
        }
      });
      document.addEventListener('click', handleDocumentClick);
    }

    section.oddItProductGridCleanup = function () {
      document.removeEventListener('click', handleDocumentClick);
      if (typeof mobileQuery.removeEventListener === 'function') {
        mobileQuery.removeEventListener('change', syncSidebarVisibility);
      }
      document.body.style.overflow = '';
    };
  }

  function destroySection(section) {
    if (section && typeof section.oddItProductGridCleanup === 'function') {
      section.oddItProductGridCleanup();
      section.oddItProductGridCleanup = null;
      section.oddItProductGridInitialized = false;
    }
  }

  document.querySelectorAll('.oddit-section-product-grid').forEach(initSection);

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target && event.target.querySelector
      ? event.target.querySelector('.oddit-section-product-grid')
      : null;
    if (section) initSection(section);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    var section = event.target && event.target.querySelector
      ? event.target.querySelector('.oddit-section-product-grid')
      : null;
    if (section) destroySection(section);
  });
})();
